export default "__VITE_ASSET__ndiYuBE4__"